<template>
  <div v-if="isDataLoaded" id="view-panorama-container">
    
    <div class="container is-fluid levebar-container">
      <nav class="level app-levelbar">
        <div class="level-left is-hidden-mobile">
          <breadcrumb v-if="breadcrumbList" :list="breadcrumbList"></breadcrumb>
        </div>
      </nav>
    </div>

    <panorama-container :panoramaData="panorama" v-if="panorama"></panorama-container>
  </div>
</template>

<script>
  import Breadcrumb from '../Util/Breadcrumb'
  import PanoramaContainer from './PanoramaContainer'

  export default {
    components: {
      Breadcrumb,
      PanoramaContainer
    },

    data () {
      return {
        breadcrumbList: null,
        isDataLoaded: false
      }
    },

    mounted () {
      this.getPanoramaData()
      this.getCoachData()
    },

    computed: {
      currentEvent () {
        return window.store.state.event.nextEvent
      },

      coach () {
        return this.$store.state.coach.data
      },

      panorama () {
        return this.$store.state.panorama.data
      }
    },

    methods: {
      getPanoramaData () {
        this.$store.dispatch('getPanorama', this.$store.state.route.params.id)
      },

      getCoachData () {
        this.$store.dispatch('getCoach', this.$store.state.route.params.id)
      }
    },

    watch: {
      currentEvent: function (val) {
      },

      coach: function (val) {
        if (val) {
          let id = val.id
          let name = val.languages[0].pivot.name

          this.breadcrumbList = [
            { name: 'Início', path: '/' },
            { name: `${name}`, path: `/${id}` },
            { name: 'VISITA VIRTUAL', path: '' }
          ]
        }
      },

      panorama: function (val) {
        if (val) {
          this.isDataLoaded = true
        }
      }
    }
  }
</script>

<style lang="scss">
  .content-padding {
    padding: 10px;
    background: white;
  }
  #view-panorama-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .container-margin-top {
    margin-top: 20px !important;
  }

  .flex-container-center {
    display: flex;
    align-items: center;
  }
</style>


// WEBPACK FOOTER //
// index.vue?57163408